import { groupBy } from 'lodash-es';
import dayjs from 'dayjs';
import { addDurationToTime } from 'utils/date';

export const menuTransformer = (menu) => {
  const servingTimes = getMenuTimes(menu);
  return {
    ...menu,
    isServing: !!servingTimes?.isServing,
    activeTime: formatActiveTime({ time: servingTimes.time, isServing: servingTimes.isServing }),
    categories: menu.categories ? menu.categories
      .map((c) => ({
        ...c,
        items: c.items,
      }))
      .filter((c) => c.items.length)
      .sort((a, b) => a.position - b.position) : [],
  };
};

export const formatActiveTime = ({ time, isServing }) => {
  const fromHour = time?.from_hour;
  const duration = time?.duration;
  try {
    if (!duration && fromHour) {
      return dayjs(fromHour, 'HH:mm:ss A').format('hh:mm A');
    }
    if (duration && fromHour) {
      const endHour = addDurationToTime(dayjs(
        fromHour,
        'HH:mm:ss A',
      ), duration);

      return `${!isServing ? `${time.weekday} ` : ''}${dayjs(fromHour, 'HH:mm:ss A').format('hh:mm A')} - ${endHour.format('hh:mm A')}`;
    }
    return 'Active times are not available';
  } catch (e) {
    return 'Active times are not available';
  }
};

export const getMenuTimes = (menu) => {
  function dayName(date) {
    return date.format('ddd').toUpperCase();
  }

  const todayName = dayName(dayjs());
  if (!menu.active_hours?.length) {
    return {};
  }

  const servingTimes = groupBy(menu.active_hours, 'weekday');
  const todayServingTimes = servingTimes[todayName];

  if (todayServingTimes?.length > 0) {
    const currentWorkingTime = todayServingTimes.find(({
      from_hour: fromHour,
      duration,
    }) => checkCurrentTimeIsActiveHour(fromHour, duration));
    if (currentWorkingTime) {
      return { isServing: true, time: currentWorkingTime };
    }
    const nextWorkingTime = todayServingTimes.find(({ from_hour: fromHour }) => dayjs(fromHour, 'HH:mm:ss').isAfter(dayjs()));
    if (nextWorkingTime) {
      return { isServing: false, time: nextWorkingTime };
    }
  }

  let nextDay = dayjs().add(1, 'days');
  let nextAvailableTime = null;
  while (dayName(nextDay) !== todayName && !nextAvailableTime) {
    if (servingTimes[dayName(nextDay)]?.length > 0) {
      [nextAvailableTime] = servingTimes[dayName(nextDay)].sort(({ from_hour: a }, { from_hour: b }) => dayjs(a, 'HH:mm:ss').valueOf() - dayjs(b, 'HH:mm:ss').valueOf());
      return { isServing: false, time: nextAvailableTime };
    }
    nextDay = dayjs(nextDay).add(1, 'days');
  }

  return { isServing: false };
};

const checkCurrentTimeIsActiveHour = (from_hour, duration) => {
  const currentTime = dayjs();
  const fromHour = dayjs(from_hour, 'HH:mm:ss');
  const endHour = addDurationToTime(fromHour, duration);

  // - fromHour: The start time of the active period
  // - endHour: The end time calculated from start time + duration
  // - 'minute': Compare times down to the minute level
  // - '[]': Include both start and end times in the valid range
  return currentTime.isBetween(fromHour, endHour, 'minute', '[]');
};
